import { Injector } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Store } from '@ngrx/store';
import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';
import { isAsyncValueProviderType } from '@ordersnproducts/modules/shared/models/async-value';
import { Observable, of } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { OneClickState } from '../reducers';

export class StandardLotZeroValidator {
  static validator(store: Store<OneClickState>, currentItem: RecipeFormValues, injector: Injector): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      return of(control.value).pipe(
        debounceTime(200),
        filter(val => !isAsyncValueProviderType(val)),
        map(val => +extractNumber(val)),
        map(qty => {
          if (qty > 0) {
            return null;
          } else {
            return { errorMessage: 'views.specification.invalid_std_lot' };
          }
        }),
      );
    };
  }
}

/**
 * Extracts numeric part from string like "27.5 TN"
 * @param value
 */
function extractNumber(value: string) {
  const valueNumericPart = value && value.match(/\d+(\.\d+)?/);
  return valueNumericPart && valueNumericPart[0];
}
